import { createSettingsListApi } from './settings-list-api.factory';

export const recordProtectionMeansApi = createSettingsListApi('/record-protection-means');
